import MarketingGroupFormPage from "./marketingGroupFormPage";

const UpdateMarketingGroup = () => <MarketingGroupFormPage mode="edit" />;

export default UpdateMarketingGroup;
